import { createContext } from 'react';

export const InitialApplicationContext = createContext({});
InitialApplicationContext.displayName = 'InitialApplicationContext';

export default InitialApplicationContext;
